import { createContext } from 'react'

export const TooltipProviderContextProvider = createContext()

export const TooltipContextProvider = createContext()

export const TooltipContentContextProvider = createContext()
